




import Vue from 'vue'
import Component from 'vue-class-component'

@Component<HeartBorder>({
  props: {
    color1: {
      type: String,
      default : "#838383"
    }
  }
})

export default class HeartBorder extends Vue {
  /**
   * Props variables
   */
  color1: string | undefined

  /**
   * Component state variables
   */


  /**
   * Lifecycle
   */


  /**
   * Getters
   */


  /**
   * Methods
   */

}
